import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/layout';
import { Tag, TagLabel, Tooltip } from '@chakra-ui/react';
import useTranslation from '../../../lib/i18n/useTranslation';

export default function SharedExperienceUserTempListItem(props) {
  const { t } = useTranslation();
  const {
    userTemp,
  } = props;  
  return (
    <>
      {userTemp && (
        <Flex
          justifyContent="space-between"
          alignItems="center"
          px={3}
          py={3}
          backgroundColor="white"
        >
          <Flex alignItems={'center'}>
            <Box
              w="40px"
              h="40px"
              borderRadius="50%"
              backgroundColor="background.grey"
              display="flex"
              alignItems="center"
              justifyContent="center"
              mr={2}
            >
              <Text fontSize="sm" fontWeight="bold" color="text.light.grey">
                {userTemp?.email?.charAt(0).toUpperCase()}
              </Text>
            </Box>
            <Box>
              <Text>{userTemp.email}</Text>
            </Box>
          </Flex>
          <Flex>
            <Tooltip label={t('members.invitedTooltip')}>
              <Tag variant="orange">
                  <TagLabel px={2}>{t('common.invited')}</TagLabel>
              </Tag>
            </Tooltip>
          </Flex>
        </Flex>
      )}
    </>
  );
} 